import { MutableRefObject } from 'react';
import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import {
  Button,
  CustomIcons,
  Modal,
  Stack,
  Text,
  Card,
  styled,
  ModalProps,
} from '@/theme/index';

const StyledModal = styled(Modal)({
  position: 'absolute',
  '.MuiDialog-container': { height: 'unset' },
  '.MuiDialogContent-root': {
    padding: 0,
  },
});

interface ForgotLoginModalProps extends ModalProps {
  /** The parent container for this modal, useful for positioning */
  containerRef: MutableRefObject<null>;
}

/** This component shows the user the info for reaching our customer support team */
export const ForgotLoginModal: React.FC<ForgotLoginModalProps> = ({
  containerRef,
  open,
  onClose,
}) => {
  const {
    data: { supportPhone },
  } = useAppConstantsContext();
  const { navigate, location } = useAppConfigContext().routingUtils;
  const customerSupportSchedule = { days: 'Mon - Fri', hours: '9am - 5pm EST' };

  const handleClose = () => {
    navigate('/login');
  };

  return (
    <StyledModal
      open={open || location.pathname === '/login/forgot-email'}
      PaperProps={{ sx: { padding: 3, minWidth: { md: 658, xs: 320 } } }}
      container={containerRef.current}
      onClose={onClose || handleClose}
    >
      <Stack spacing={2.5} alignItems="center">
        <Text variant="h3" lineHeight={1.2} sx={{ margin: 0 }}>
          Unsure what email you used?
        </Text>
        <Card variant="outlined" sx={{ width: '100%' }}>
          <Stack
            spacing={1}
            marginBottom={0.5}
            alignItems="center"
            textAlign="center"
          >
            <CustomIcons.CustomerSupportCharacterIcon
              viewBox="0 0 40 40"
              fontSize="large"
            />
            <Text variant="h5" lineHeight={1.2}>
              Contact customer care for help with locating your account
            </Text>
            <Text variant="h3" lineHeight={1.2} sx={{ margin: 0 }}>
              {supportPhone}
            </Text>
            <Stack direction="row" spacing={1}>
              <Text variant="h5" lineHeight={1.2} sx={{ margin: 0 }}>
                Open {customerSupportSchedule.days}
              </Text>
              <Text lineHeight={1.2}>{customerSupportSchedule.hours}</Text>
            </Stack>
          </Stack>
        </Card>
        <Button variant="contained" onClick={handleClose} color="success">
          Return to login
        </Button>
      </Stack>
    </StyledModal>
  );
};
